// "Manage Cookies" footer label per supported locale. English fallback.
// TODO(JS-XXXXX follow-up): migrate to a DatoCMS footer field.
const DEFAULT_LABEL = "Manage Cookies";
const MANAGE_COOKIES_LABELS: Record<string, string> = {
  en_US: "Manage Cookies",
  en_GB: "Manage Cookies",
  de_DE: "Cookies verwalten",
  da: "Administrer cookies",
  es_ES: "Gestionar cookies",
  es_MX: "Gestionar cookies",
  fi: "Hallitse evästeitä",
  fr_CA: "Gérer les cookies",
  fr_FR: "Gérer les cookies",
  hi_IN: "कुकीज़ प्रबंधित करें",
  it: "Gestisci i cookie",
  ja: "Cookieの管理",
  ko: "쿠키 관리",
  nl: "Cookies beheren",
  no: "Administrer informasjonskapsler",
  pl: "Zarządzaj plikami cookie",
  pt_BR: "Gerenciar cookies",
  pt_PT: "Gerir cookies",
  ru: "Управление файлами cookie",
  sv: "Hantera cookies",
  zh_CN: "管理 Cookie"
};
export function getManageCookiesLabel(locale: string): string {
  return MANAGE_COOKIES_LABELS[locale] ?? DEFAULT_LABEL;
}